import { MouseEventHandler, useMemo } from "react";
import { ClickableElementLinkInfo } from "shared/components/clickable/ClickableElementLinkInfo";
import { useClickableElementOnClickHandler } from "shared/components/clickable/ClickableElementOnClickHandler";

export const useClickableElementProps = (
  linkInfo: ClickableElementLinkInfo | undefined,
):
  | {
      tabIndex: number;
      onMouseDown: MouseEventHandler<HTMLElement>;
      onClick: MouseEventHandler<HTMLElement>;
    }
  | undefined => {
  const linkHandler = useClickableElementOnClickHandler();
  return useMemo(
    () =>
      linkInfo?.type === "generic"
        ? {
            tabIndex: 0,
            onMouseDown: (event) => {
              event.preventDefault();
            },
            onClick: (event) => {
              linkHandler(linkInfo, event);
            },
          }
        : undefined,
    [linkInfo, linkHandler],
  );
};
